import { FC } from 'react';

import _ from 'lodash';
import { useFormContext } from 'react-hook-form';

import {
  CROWDING_EXTRACTION,
  CROWDING_EXTRACTION_VALUES
} from 'constants/prescriptionOptions';
import { translate } from 'utils';

import DentitionTypeWithToothCharts from './DentitionTypeWithToothCharts/DentitionTypeWithToothCharts';
import { FormLabel } from './FormLabel/FormLabel';
import { If } from './Generics';
import RhfRadioGroup from './RadioGroup/RhfRadioGroup/RhfRadioGroup';

const EXTRACTION_FIELD_PREFIX =
  'treatmentSpecifications.ZenClearUltra.extraction';

interface Props {
  isDisabled?: boolean;
  isUpperDisabled?: boolean;
  isLowerDisabled?: boolean;
}
const CrowdingExtraction: FC<Props> = ({
  isDisabled,
  isUpperDisabled,
  isLowerDisabled
}) => {
  const {
    watch,
    formState: { errors }
  } = useFormContext();
  const watchExtraction = watch(`${EXTRACTION_FIELD_PREFIX}.Extraction`);
  const restrictedAdultToothChartValue = watch(
    'treatmentSpecifications.ZenClearUltra.toothInformation.toothChart'
  );
  const restrictedPrimaryToothChartValue = watch(
    'treatmentSpecifications.ZenClearUltra.toothInformation.primaryToothChart'
  );
  const fieldError = _.get(errors, EXTRACTION_FIELD_PREFIX);

  return (
    <div className='mt-5'>
      <FormLabel
        label={translate('prescription.step16_extraction')}
        className='md:text-17px mb-4'
        error={!!fieldError}
        name={'extraction'}
      />
      <RhfRadioGroup
        inputProps={{ disabled: isDisabled }}
        options={CROWDING_EXTRACTION}
        name={`${EXTRACTION_FIELD_PREFIX}.Extraction`}
        className=' flex flex-row space-x-16'
        radioClassName='border-RADIO_BORDER'
        radioItemFont='md:text-17px text-sm '
      />
      <If condition={watchExtraction === CROWDING_EXTRACTION_VALUES.EXTRACTION}>
        <div className='my-6 ml-5'>
          <DentitionTypeWithToothCharts
            dentitionSelectionName={`${EXTRACTION_FIELD_PREFIX}.dentitionSelection`}
            adultChartName={`${EXTRACTION_FIELD_PREFIX}.toothChart`}
            primaryChartName={`${EXTRACTION_FIELD_PREFIX}.primaryToothChart`}
            disabled={isDisabled}
            isUpperDisabled={isUpperDisabled}
            isLowerDisabled={isLowerDisabled}
            isToothChartRestricted={true}
            restrictedAdultToothChartValue={restrictedAdultToothChartValue}
            restrictedPrimaryToothChartValue={restrictedPrimaryToothChartValue}
            isCrowdExtraction={true}
          />
        </div>
      </If>
    </div>
  );
};
export default CrowdingExtraction;
